export default "__VITE_ASSET__CPnyaVDt__"